import SignupForm from "../components/SignupForm"
import { useFetchUserDataQuery } from "../../../app/userApiSlice"
import useAuth from "../../../hooks/useAuth"

const SignupPage = () => {
  const { uid } = useAuth()
  const { data } = useFetchUserDataQuery(uid)

  return (
    <SignupForm membership={data?.membership} existingAccountType={data?.accountType} />
  )
}

export default SignupPage